export default __webpack_public_path__ + "static/media/ux.e3b046a4.svg";